import { Component } from 'react';

import { mapStackTrace } from 'sourcemapped-stacktrace';

import { logErrorWrapper } from '../../../../services/logWrapper';

import type { AppErrorBoundaryProps, AppErrorBoundaryState } from './types';

class AppErrorBoundary extends Component<
  AppErrorBoundaryProps,
  AppErrorBoundaryState
> {
  state: AppErrorBoundaryState = { hasError: false };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({ hasError: true });
    const { location, prefix } = this.props;

    const defaultPrefix = `AppErrorBoundary - `;

    mapStackTrace(error.stack, (mappedStack) => {
      const stackInfo = info?.componentStack ?? '';
      logErrorWrapper(error, {
        component: `${prefix ?? defaultPrefix}${location}`,
        message: `Month view render error: ${error}`,
        stackTrace: `${mappedStack}\n${stackInfo}`,
      });
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>&nbsp;</h1>;
    }
    return this.props.children;
  }
}

export default AppErrorBoundary;
